import { reactive } from 'vue';
import apis from "@/api";
import { USERINFO } from "@/store/mutation-types";
import dayjs from "dayjs";
export default function common() {
  const commonData = reactive({
    roles: [],
    designers: [],
    userInfo: {},
    defaultRangeTime: [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)],
    belongDeparts: [{
      code: 'jike',
      label: '集客',
      name: '集客'
    }, {
      code: 'shichang',
      label: '市场',
      name: '集客'
    }],
    srcBelongDeparts: [{
      code: '0000',
      label: '省公司',
      name: '省公司'
    }, {
      code: '0691',
      label: '版纳公司',
      name: '版纳公司'
    }, {
      code: '0692',
      label: '德宏公司',
      name: '德宏公司'
    }, {
      code: '0870',
      label: '昭通公司',
      name: '昭通公司'
    }, {
      code: '0871',
      label: '昆明公司',
      name: '昆明公司'
    }, {
      code: '0872',
      label: '大理公司',
      name: '大理公司'
    }, {
      code: '0873',
      label: '红河公司',
      name: '红河公司'
    }, {
      code: '0874',
      label: '曲靖公司',
      name: '曲靖公司'
    }, {
      code: '0875',
      label: '保山公司',
      name: '保山公司'
    }, {
      code: '0876',
      label: '文山公司',
      name: '文山公司'
    }, {
      code: '0877',
      label: '玉溪公司',
      name: '玉溪公司'
    }, {
      code: '0878',
      label: '楚雄公司',
      name: '楚雄公司'
    }, {
      code: '0879',
      label: '普洱公司',
      name: '普洱公司'
    }, {
      code: '0883',
      label: '临沧公司',
      name: '临沧公司'
    }, {
      code: '0886',
      label: '怒江公司',
      name: '怒江公司'
    }, {
      code: '0887',
      label: '迪庆公司',
      name: '迪庆公司'
    }, {
      code: '0888',
      label: '丽江公司',
      name: '丽江公司'
    }]
  });
  const smsProcs = [{
    content: "新建需求",
    timestamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    opterName: JSON.parse(window.localStorage.getItem(USERINFO)).userName,
    size: "large",
    type: "primary",
    color: "#0bbd87"
  }, {
    content: "需求进行中",
    timestamp: ""
  }, {
    content: "需求完成",
    timestamp: ""
  }];
  const srcProcs = [{
    content: "新建需求",
    timestamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    opterName: JSON.parse(window.localStorage.getItem(USERINFO)).userName,
    size: "large",
    type: "primary",
    color: "#0bbd87"
  }, {
    content: "领导审核",
    timestamp: ""
  }, {
    content: "需求进行中",
    timestamp: ""
  }, {
    content: "需求完成",
    timestamp: ""
  }];
  const smsAuditRoleAuth = {
    'yewuSms': 'needs:yewu:sms',
    'jikeSms': 'needs:jike:sms',
    'fawu_sms': 'needs:fawu_sms',
    'keti_sms': 'needs:keti_sms',
    'zaixian': 'needs:zaixian'
  };
  const smsAuditRoles = [{
    roleId: 'yewuSms',
    roleName: '业务',
    auth: 'needs:yewu:sms'
  }, {
    roleId: 'jikeSms',
    roleName: '集客',
    auth: 'needs:jike:sms'
  }, {
    roleId: 'fawu_sms',
    roleName: '法务',
    auth: 'needs:fawu_sms'
  }, {
    roleId: 'keti_sms',
    roleName: '客体',
    auth: 'needs:keti_sms'
  }, {
    roleId: 'zaixian',
    roleName: '在线',
    auth: 'needs:zaixian'
  }];
  const srcAuditRoles = [{
    roleId: 'yewu',
    roleName: '需求人',
    auth: 'needs:yewu'
  }, {
    roleId: 'fawu_src',
    roleName: '法务',
    auth: 'needs:fawu_src'
    // },
    // {
    //     roleId: 'keti',
    //     roleName: '客体',
    //     auth: 'needs:keti'
    // },
    // {
    //     roleId: 'zaixian',
    //     roleName: '在线',
    //     auth: 'needs:zaixian'
  }];
  const advAuditRoles = [{
    roleId: 'yewu',
    roleName: '需求人',
    auth: 'needs:yewu'
  }, {
    roleId: 'fawu_src',
    roleName: '法务',
    auth: 'needs:fawu_src'
  }, {
    roleId: 'keti_src',
    roleName: '客体',
    auth: 'needs:keti_src'
  }];
  const getSrcType = type => {
    switch (type) {
      case '1':
        return "图片";
      case '2':
        return "音频";
      case '3':
        return "视频";
      case '4':
        return "文本";
      case '5':
        return "源文件";
      case '6':
        return "其它";
    }
  };
  const getSrcState = state => {
    switch (state) {
      case -1:
        return "审批驳回";
      case 0:
        return "待审核";
      case 1:
        return "待入库";
      case 2:
        return "已入库";
    }
  };
  const getRolesOfLogin = () => {
    apis.rolesOfLogin().then(res => {
      if (res.success) {
        commonData.roles = res.data;
      } else {
        ElMessage.error('获取登录用户角色失败');
      }
    });
  };
  const getDesignCompanies = params => {
    apis.getDesignersByDepart(params).then(res => {
      if (res.success) {
        commonData.designers = res.data;
      } else {
        ElMessage.error(res.msg);
      }
    });
  };
  const initUserInfo = () => {
    // return store.state.userInfo
    const user = window.localStorage.getItem(USERINFO);
    commonData.userInfo = JSON.parse(user);
  };
  const disabledDate = currentDate => {
    const maxDate = dayjs().add(1, 'year');
    const yesterday = dayjs().add(-1, 'day');
    return yesterday.isAfter(currentDate) || maxDate.isBefore(currentDate);
  };
  const getAreaByCode = area => {
    for (const src of commonData.srcBelongDeparts) {
      if (src.code === area) {
        return src.name;
      }
    }
    return '';
  };
  return {
    commonData,
    smsAuditRoles,
    srcAuditRoles,
    advAuditRoles,
    srcProcs,
    smsProcs,
    smsAuditRoleAuth,
    getSrcType,
    getSrcState,
    getRolesOfLogin,
    initUserInfo,
    getDesignCompanies,
    disabledDate,
    getAreaByCode
  };
}